<p-dialog [visible]="true" [closable]="false" [showHeader]="false" [style]="{ 'min-width': '15vw', 'max-height': '75vh' }">
    <div
        [hidden]="supported()"
        style="overflow: auto; max-width: 350px; max-height: 500px"
    >
        Your current internet browser/version is not compatible with eFAACT
        Central. We recommend using the new
        <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a> or the
        latest version of
        <a href="https://www.google.com/chrome/">Google Chrome</a>,
        <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>, or
        <a href="https://support.apple.com/downloads/safari">Safari</a>. If
        unable to update your internet browser, login to the previous eFAACT Web
        site via
        <a href="https://timeandexpense.myefaactweb.com"
            >https://timeandexpense.myefaactweb.com</a
        >.
    </div>
    <div class="mt-4 w-full h-full" [hidden]="!supported()">
        <div class="flex justify-content-center">
            <div *ngIf="(this.logo$ | async) != null">
                <img
                    [src]="(this.logo$ | async)?.Uploadfile"
                    style="max-height: 150px; max-width: 750px"
                />
            </div>
        </div>
        <div class="flex justify-content-center">
            <h2 class="text-600 text-base mt-4 mb-3">eFAACT Central Login</h2>
        </div>

        <form [formGroup]="loginForm" class="h-full w-full">
            <div class="mb-4" [hidden]="!signInData.message">
                <p-message severity="error">{{ signInData.message }}</p-message>
            </div>
            <div
                class="h-full w-full"
                [hidden]="
                    signInData.status !== LoginRequestStatus.Undefined &&
                    signInData.status !==
                        LoginRequestStatus.SubmitUsernamePasswordAndPIN
                "
            >
                <p-floatLabel variant="on">
                    <input
                        class="w-full"
                        pInputText
                        id="username"
                        formControlName="username"
                        onfocus="this.select();"
                    />
                    <label for="username">Username</label>
                </p-floatLabel>
                <p-floatLabel variant="on" class="mt-3 mb-3">
                    <p-password 
                        fluid 
                        id="password" 
                        styleClass="w-full" 
                        formControlName="password"
                        onfocus="this.select();" 
                        [toggleMask]="true"
                        [feedback]="false">
                    </p-password>
                    <!-- <input
                        class="w-full"
                        pInputText
                        type="password"
                        id="password"
                        formControlName="password"
                        onfocus="this.select();"
                        maxlength="128"
                    /> -->
                    <label for="password">Password</label>
                </p-floatLabel>
                <p-floatLabel variant="on">
                    <input
                        class="w-full"
                        pInputText
                        type="text"
                        id="pin"
                        formControlName="pin"
                        onfocus="this.select();"
                    />
                    <label for="pin">PIN/Customer ID</label>
                </p-floatLabel>

                <span>
                    <button
                        pButton
                        pRipple
                        style="font-size: smaller; text-align: left"
                        type="button"
                        class="p-button-text"
                        label="Forgot Password?"
                        title="Forgot Password?"
                        [disabled]="
                            loginForm.controls['username'].invalid ||
                            loginForm.controls['pin'].invalid ||
                            isAdminUsername()
                        "
                        (click)="onForgotPassword()"
                    ></button>
                </span>
                <div class="flex items-center mb-2 mt-2">
                    <p-checkbox
                        #rememberMe
                        binary="true"
                        [formControl]="loginForm.controls['rememberMe']"
                        (onChange)="rememberMeChanged(rememberMe.checked)"
                    ></p-checkbox>
                    <label class="ml-2">Remember Me</label>
                </div>

            </div>

            <div
                class="mb-4"
                [hidden]="
                    signInData.status !==
                    LoginRequestStatus.SelectAccessCodeMethod
                "
            >
                <p-select
                    styleClass="w-full"
                    id="login-access-code-type"
                    placeholder="Access Code Method"
                    appendTo="body"
                    formControlName="accessCodeDeliveryType"
                    [options]="signInData.accessCodeRequestMethods"
                    optionLabel="DisplayName"
                    dataKey="Value"
                    baseZIndex="2000"
                >
                </p-select>
            </div>

            <div
                [hidden]="
                    signInData.status !== LoginRequestStatus.AccessCodeSent
                "
            >
                <input
                    class="w-full"
                    pInputText
                    id="access-code"
                    placeholder="Access Code"
                    formControlName="accessCode"
                />
            </div>
            <label
                [hidden]="
                    signInData.status !== LoginRequestStatus.AccessCodeSent
                "
                for="access-code"
                style="font-style: italic; font-size: small; color: gray"
                class="mb-4"
            >
                sent via email or text
            </label>
            <div
                class="mb-4"
                [hidden]="
                    signInData.status !==
                    LoginRequestStatus.AnswerSecurityQuestion
                "
            >
                <label for="securityAnswer">{{
                    signInData.securityQuestion
                }}</label>
                <input
                    id="security-answer"
                    pInputText
                    placeholder="Security Answer"
                    formControlName="securityAnswer"
                    class="w-full"
                />
            </div>

            <div class="grid">
                <div class="col-12">
                    <button
                        class="w-full"
                        id="submit"
                        type="submit"
                        pButton
                        pRipple
                        severity="primary"
                        (click)="login()"
                        label="Log in"
                        [disabled]="loginForm.invalid"
                    ></button>
                </div>
                <!-- <div class="col-12">
                    <button
                        class="w-full"
                        id="cancel"
                        type="button"
                        severity="secondary"
                        pButton
                        pRipple
                        (click)="close()"
                        label="Cancel"
                        [hidden]="
                            signInData.status ===
                            LoginRequestStatus.SubmitUsernamePasswordAndPIN
                        "
                    ></button>
                </div> -->
            </div>
        </form>
    </div>
</p-dialog>
